import React from "react";

const QuranTafsirPopupPanel = ({
  uiLabels,
  truncateLabel,
  tafsirLanguageMenuRef,
  tafsirOptionsLoading,
  tafsirLanguageMenuOpen,
  setTafsirLanguageMenuOpen,
  tafsirLanguageOptions,
  tafsirLanguageCode,
  onChangeTafsirLanguage,
  tafsirBookMenuRef,
  tafsirBookMenuSuppressUntilRef,
  tafsirResources,
  tafsirBookMenuOpen,
  setTafsirBookMenuOpen,
  tafsirResourceId,
  onChangeTafsirBook,
}) => (
  <div className="quran-translation-controls">
    <label className="quran-translation-control">
      <span>{uiLabels.language}</span>
      <div className="quran-book-select" ref={tafsirLanguageMenuRef}>
        <button
          type="button"
          className="quran-book-trigger"
          onClick={(event) => {
            event.stopPropagation();
            setTafsirLanguageMenuOpen((prev) => !prev);
          }}
          disabled={tafsirOptionsLoading}
          aria-expanded={tafsirLanguageMenuOpen}
        >
          <span>
            {truncateLabel(
              tafsirLanguageOptions.find((lang) => lang.code === tafsirLanguageCode)
                ? `${
                    tafsirLanguageOptions.find((lang) => lang.code === tafsirLanguageCode)?.nativeName ||
                    tafsirLanguageOptions.find((lang) => lang.code === tafsirLanguageCode)?.name
                  } (${tafsirLanguageCode})`
                : tafsirLanguageCode.toUpperCase(),
              34
            )}
          </span>
          <span className="quran-book-caret">▾</span>
        </button>

        {tafsirLanguageMenuOpen && (
          <div className="quran-book-menu" role="listbox" onClick={(event) => event.stopPropagation()}>
            {tafsirLanguageOptions.map((lang) => (
              <button
                type="button"
                key={`tafsir-lang-${lang.code}`}
                className={`quran-book-option ${
                  lang.code === tafsirLanguageCode ? "quran-book-option--active" : ""
                }`}
                onClick={(event) => {
                  event.stopPropagation();
                  onChangeTafsirLanguage(lang.code);
                }}
                title={lang.nativeName ? `${lang.nativeName} (${lang.code})` : `${lang.name} (${lang.code})`}
              >
                {truncateLabel(
                  lang.nativeName ? `${lang.nativeName} (${lang.code})` : `${lang.name} (${lang.code})`,
                  34
                )}
              </button>
            ))}
          </div>
        )}
      </div>
    </label>

    <label className="quran-translation-control">
      <span>{uiLabels.tafsir}</span>
      <div className="quran-book-select" ref={tafsirBookMenuRef}>
        <button
          type="button"
          className="quran-book-trigger"
          onClick={(event) => {
            event.stopPropagation();
            if (Date.now() < tafsirBookMenuSuppressUntilRef.current) {
              return;
            }
            setTafsirBookMenuOpen((prev) => !prev);
          }}
          disabled={tafsirOptionsLoading || tafsirResources.length === 0}
          aria-expanded={tafsirBookMenuOpen}
        >
          <span>
            {truncateLabel(
              tafsirResources.find((resource) => resource.id === tafsirResourceId)?.name ||
                (tafsirResources.length === 0 ? uiLabels.noTafsir : uiLabels.chooseTafsir),
              34
            )}
          </span>
          <span className="quran-book-caret">▾</span>
        </button>

        {tafsirBookMenuOpen && tafsirResources.length > 0 && (
          <div className="quran-book-menu" role="listbox" onClick={(event) => event.stopPropagation()}>
            {tafsirResources.map((resource) => (
              <button
                type="button"
                key={`tafsir-book-${resource.id}`}
                className={`quran-book-option ${
                  resource.id === tafsirResourceId ? "quran-book-option--active" : ""
                }`}
                onClick={(event) => {
                  event.stopPropagation();
                  onChangeTafsirBook(resource.id);
                }}
                title={resource.name || `Tafsir ${resource.id}`}
              >
                {truncateLabel(resource.name || `Tafsir ${resource.id}`, 36)}
              </button>
            ))}
          </div>
        )}
      </div>
    </label>
  </div>
);

export default QuranTafsirPopupPanel;